import { ThemeMode } from "cms/theme/theme";
import Styled from "styled-components";

export interface TableRowProps {
  $noBorder?: boolean;
}

export interface TableCellProps {
  $isSticky?: boolean;
  $passedTheme?: ThemeMode;
}

export const Container = Styled.div`
  padding: 2rem 0;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  
    ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 10rem);
  }

`;

export const TableWrapper = Styled.div`
  display: flex;
  overflow-x: auto;
  max-width: 100%;

  ${(props) => props.theme.breakpoints.up("large")} {
    overflow-x: hidden;
  }
`;

export const TableHeadlineContainer = Styled.div`
  display: inline-block;
  width: 100%;
`;

export const Table = Styled.table`
  flex: 1;
  table-layout: auto;
  border-collapse: collapse;
  width: 100%;

  ${(props) => props.theme.breakpoints.up("large")} {
    table-layout: fixed;
  }
`;

export const TableBody = Styled.tbody`

`;

export const TableHead = Styled.thead`
  display: none;
`;

export const TableCaption = Styled.caption`
  display: none;
`;

export const TableCell = Styled.td<TableCellProps>`
  display: table-cell;
  text-align: center;
  padding: 0.5rem 1rem;
  color: inherit;
  font-size: 1rem;
  line-height: 1.25rem;
  letter-spacing: -0.1px;

  ${(props) =>
    props.$isSticky &&
    `
    position: sticky;
    left: 0;
    background-color: ${props.$passedTheme === "dark" ? "#030303" : "#FFFF"};
    z-index: 1;
  `}

  ${(props) => props.theme.breakpoints.up("large")} {
    line-height: 1.624rem;
    width: 13.375rem;
    text-align: center;
    padding: 0.5rem 0;
  }
`;

export const TableRow = Styled.tr<TableRowProps>`
  border-bottom: 1px solid #eeeeee;

  ${TableCell}:first-of-type {
    text-align: left;
  }

  ${(props) =>
    props.$noBorder &&
    `
    border: transparent;
  `};
`;

export const ButtonContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  width: 100%;
`;

export const ListItemIcon = Styled.span`
  font-size: 1rem;
`;
